import { TransportOrderIdView } from '../../../../models';

export class ShipmentTransportOrderOverviewLoad {
  public static readonly type = '[ShipmentTransportOrderOverview] Load Overview';
  constructor(public payload: TransportOrderIdView) {}
}

export class ShipmentTransportOrderOverviewSetInitialState {
  public static readonly type = '[ShipmentTransportOrderOverview] Set Initial State';
}
